module.exports = __webpack_public_path__ + "static/media/cn.ef32ba81.svg";